import { loadSessionField } from '../../../../auth/sessionProfileStore'
import { buildFlatRows } from '../metricsExport'
import {
  headerValue,
  tableValue,
  moneyCell,
  percentCell
} from '../tableUtils'
import {
  buildFillRateExportFilename,
  resolveFillRateDifference
} from '../fillRateMetrics'

const toDisplayedDifferenceAmount = (value) =>
  value ? -Number(value) : 0

const differenceCell = (value) => {
  const amount = toDisplayedDifferenceAmount(value)

  if (amount === 0) return '-'
  return moneyCell(amount)
}

export const exportMetricsExcel = (
  summary,
  totals,
  metrics,
  dateRange
) => {
  const rows = []
  const flatRows = buildFlatRows(summary, totals)

  /*  HEADER  */
  rows.push(['REPORTE:', 'Fill Rate por cadena'])
  rows.push(['PERIODO:', headerValue(dateRange)])
  rows.push(['GENERADO:', new Date().toLocaleString()])
  rows.push([''])

  /*  METRICS  */
  rows.push(['MÉTRICAS'])
  rows.push([''])
  rows.push(['ÓRDENES RECIBIDAS:', headerValue(metrics?.received_orders)])
  rows.push(['PROCESADAS:', headerValue(metrics?.processed_orders)])
  rows.push(['TOTAL FACTURADO:', moneyCell(metrics?.total_facturado)])
  rows.push(['TICKET PROMEDIO:', moneyCell(metrics?.ticket_promedio)])
  rows.push([''])
  rows.push([''])

  /*  TABLE  */
  rows.push([
    'CADENA',
    'OC CANT.',
    'OC MONTO',
    'PEDIDOS CANT.',
    'PEDIDOS MONTO',
    'FILL RATE PEDIDOS',
    'DIFERENCIA',
    'PEDIDOS ERP',
    'FILL RATE ERP',
    'FACTURA',
    'FILL RATE FACT.'
  ])

  flatRows.forEach(row => {
    // BUYER / SUBTOTAL / TOTAL
    if (row.__type !== 'child') {
      rows.push([
        tableValue(row.buyer),
        tableValue(row.purchase_order_counts),
        moneyCell(row.purchase_order_total),
        tableValue(row.order_counts),
        moneyCell(row.order_total),
        percentCell(row.fill_rate_order),
        differenceCell(resolveFillRateDifference(row)),
        moneyCell(row.salesorder_total),
        percentCell(row.fill_rate_sales),
        moneyCell(row.invoice_total),
        percentCell(row.fill_rate_invoice)
      ])
    }

    if (row.__type === 'child') {
      rows.push([
        `${row.category}`,
        '',
        moneyCell(row.purchase_order_total),
        '',
        moneyCell(row.order_total),
        '',
        differenceCell(resolveFillRateDifference({
          purchase_order_total: row.purchase_order_total,
          order_total: row.order_total
        })),
        moneyCell(row.salesorder_total),
        '',
        moneyCell(row.invoice_total),
        ''
      ])
    }
  })

  const csv = rows
    .map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
    .join('\n')

  const blob = new Blob([csv], {
    type: 'text/csv;charset=utf-8;'
  })

  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = buildFillRateExportFilename(loadSessionField('business'), 'csv')
  link.click()
}
